import type { IconProps } from './types';
import './icons.css';

export default function Selected({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 13}
      height={height || 11}
      viewBox="0 0 13 11"
      className={`icon icon-selected ${className || ''}`}
      stroke="currentColor"
    >
      <path fill="none" d="M12.45 1.25l-8.4 8.5-3.5-3.542" />
    </svg>
  );
}
